import ko from '@tko/build.knockout';

ko.bindingHandlers.toggle2 = {
  init: function (element, valueAccessor) {
    var value = valueAccessor();

    if (!ko.isObservable(value)) {
      throw new Error('toggle binding should be used only with observable values');
    }

    element.addEventListener('click', (event) => {
      event.preventDefault();
      value(!value());
    });
  },

  update: function (element, valueAccessor) {
    ko.utils.toggleDomNodeCssClass(element, 'active', ko.unwrap(valueAccessor()));
  }
};


ko.bindingHandlers.checkbox2 = {
  init: function (element, valueAccessor) {
    var $element = $(element),
      handler = function (e) {
        if (event.target) { // if (event.target && event.target.matches('input[type="checkbox"]')) {
          // we need to handle change event after bootstrap will handle its event
          // to prevent incorrect changing of checkbox state
          setTimeout(function () {
            var $checkbox = $(e.target)[0],
              value = valueAccessor(),
              data = $checkbox.value,
              isChecked = $checkbox.parentElement.classList.contains('active');

            if (!$checkbox.disabled) {
              if (ko.unwrap(value) instanceof Array) {
                var index = ko.utils.arrayIndexOf(ko.unwrap(value), (data));

                if (isChecked && (index === -1)) {
                  value.push(data);
                } else if (!isChecked && (index !== -1)) {
                  value.splice(index, 1);
                }
              } else {
                value(isChecked);
              }
            }
          }, 0);
        }
      };

    if ($element.attr('data-toggle') === 'buttons' && $element.find('input:checkbox').length) {

      if (!(ko.unwrap(valueAccessor()) instanceof Array)) {
        throw new Error('checkbox binding should be used only with array or observableArray values in this case');
      }

      ko.utils.registerEventHandler(element,'change', handler);
    } else if ($element.attr('type') === 'checkbox') {

      if (!ko.isObservable(valueAccessor())) {
        throw new Error('checkbox binding should be used only with observable values in this case');
      }

      ko.utils.registerEventHandler(element,'change', handler);
    } else {
      throw new Error('checkbox binding should be used only with bootstrap checkboxes');
    }
  },

  update: function (element, valueAccessor) {
    var $element = $(element),
      value = ko.unwrap(valueAccessor()),
      isChecked;

    if (value instanceof Array) {
      if ($element.attr('data-toggle') === 'buttons') {
        $element.find('input:checkbox').each(function (index, el) {
          isChecked = ko.utils.arrayIndexOf(value, el.value) !== -1;
          $(el).parent().toggleClass('active', isChecked);
          el.checked = isChecked;
        });
      } else {
        isChecked = ko.utils.arrayIndexOf(value, $element.val()) !== -1;
        $element.toggleClass('active', isChecked);
        $element.find('input').prop('checked', isChecked);
      }
    } else {
      isChecked = !!value;
      $element.prop('checked', isChecked);
      $element.parent().toggleClass('active', isChecked);
    }
  }
};

ko.bindingHandlers.radio2 = {
  init: function (element, valueAccessor) {

    if (!ko.isObservable(valueAccessor())) {
      throw new Error('radio binding should be used only with observable values');
    }

    ko.utils.registerEventHandler(element, 'change', function (e) {
      if (event.target) { // if (event.target && event.target.matches('input[type="radio"]')) { 
        // we need to handle change event after bootsrap will handle its event
        // to prevent incorrect changing of radio button styles
        setTimeout(function () {
          var radio = $(e.target)[0],
            value = valueAccessor(),
            newValue = radio.value;

          // we shouldn't change value for disabled buttons
          if (!radio.disabled) {
            value(newValue);
          }
        }, 0);
      }
    });
  },

  update: function (element, valueAccessor) {
    var tempValue = ko.unwrap(valueAccessor()),
      value = tempValue !== null && tempValue !== undefined ? tempValue : '',
      $radioButton = $(element).find('input[value="' + value.toString().replace(/"/g, '\\"') + '"]'),
      $radioButtonWrapper;

    if ($radioButton.length) {
      $radioButtonWrapper = $radioButton.parent();

      $radioButtonWrapper.siblings().removeClass('active');
      $radioButtonWrapper.addClass('active');

      $radioButton.prop('checked', true);
    } else {
      $radioButtonWrapper = $(element).find('.active');
      $radioButtonWrapper.removeClass('active');
      $radioButtonWrapper.find('input').prop('checked', false);
    }
  }
};
